module.exports = __webpack_public_path__ + "static/media/piano.73eb3c75.svg";